module.exports = __webpack_public_path__ + "static/media/iphone.4f61c8df.png";